import { Action } from '@ngrx/store';
import { ErrorTracking } from '@shared/tracking';

export function errorHandlerReducerFactory(errorTracking: ErrorTracking) {
  return (reducer: any) => (state: any, action: Action) => {
    let nextState = state;
    try {
      nextState = reducer(state, action);
    } catch (e) {
      console.error('REDUCER ERROR: ', e);
      console.error('Broken state & action: ', state, action);
      errorTracking.captureException(e, {
        extra: { action },
      });
    }
    return nextState;
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/datastore/error-handler.reducer.ts